import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect } from 'react';
import SuceessIcon from 'src/icons/untitled-ui/duocolor/success.svg';
import ErrorIcon from '../../src/components/LoaderImg/Avatar (1).svg';

type Props = {
  isSucess?: boolean;
  title: string;
  message: string;
  close?: any;
  isClose?: boolean;
};

const styles = {
  parentBox: {
    boxShadow: '0px 5px 22px 0px rgba(0, 0, 0, 0.08)',
    background: '#FFFFFF',
    width: '334px',
    height: 'auto',
    position: 'absolute',
    bottom: 24,
    right: 24,
  },
  titleLabel: {
    color: '#111927',
    fontWeight: 700,
    fontSize: '18px',
    fontStyle: 'normal',
    marginTop: '16px',
  },
  subHeader: {
    fontSize: '14px',
    fontWeight: 400,
    marginTop: '4px',
  },
};

const SucessModal = React.forwardRef((props: Props, ref: React.Ref<HTMLDivElement>) => {
  const { isSucess = true, title, message, close, isClose = false } = props;
  
  useEffect(() => {
    if(isClose) return;
    setTimeout(() => {
      close();
    }, 4000);
  }, []);

  return (
    <Box sx={styles.parentBox}>
      <Box sx={{ padding: '24px', textAlign: 'center' }}>
        <img
          alt=""
          src={isSucess ? SuceessIcon : ErrorIcon}
        />
        <Typography sx={styles.titleLabel}>{title}</Typography>
        <Typography sx={styles.subHeader}>{message}</Typography>
      </Box>
    </Box>
  );
})

export default SucessModal;
